/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction_instance_status" */
export enum ArgoWorkInstructionInstanceStatusConstraint {
  /** unique or primary key constraint on columns "status" */
  ArgoWorkInstructionInstanceStatusPkey = 'argo_work_instruction_instance_status_pkey'
}

export enum ArgoWorkInstructionInstanceStatusEnum {
  Completed = 'completed',
  Failed = 'failed',
  InProgress = 'in_progress',
  Pending = 'pending',
  Skipped = 'skipped'
}

/** select columns of table "argo.work_instruction_instance_status" */
export enum ArgoWorkInstructionInstanceStatusSelectColumn {
  /** column name */
  Status = 'status'
}

/** update columns of table "argo.work_instruction_instance_status" */
export enum ArgoWorkInstructionInstanceStatusUpdateColumn {
  /** column name */
  Status = 'status'
}

